// extracted by mini-css-extract-plugin
module.exports = {"main":"tilesStyle_main__3f4me","container":"tilesStyle_container__1yp3v"};